// Rotas de /pages (containers/App/Router.jsx) → nome da tela em português, enviado ao agente como contexto.
// Casa primeiro pelo caminho exato e depois pelo prefixo mais longo (rotas com `:id`), sempre em limite de segmento.
const NOMES_DE_TELAS = {
  '/pages/programacao/havan': 'Programação Havan',
  '/pages/programacao/disponibilidade': 'Disponibilidade',
  '/pages/programacao/disponibilidadeFrotaPatio': 'Disponibilidade Frota Pátio',
  '/pages/programacao/criar': 'Cadastro de Disponibilidade',
  '/pages/programacao/criardisponibilidade': 'Cadastro de Disponibilidade',
  '/pages/programacao/detalhesdisponibilidade': 'Detalhes da Disponibilidade',

  '/pages/clientes': 'Clientes',
  '/pages/clientes/detalhes': 'Detalhes do Cliente',
  '/pages/clientes/cadastro': 'Cadastro de Cliente',
  '/pages/clientes/criar': 'Cadastro de Cliente',
  '/pages/clientes/editar': 'Edição de Cliente',

  '/pages/modelos/modelos': 'Modelos',
  '/pages/modelo/modelo/criar': 'Cadastro de Modelo',
  '/pages/modelo/detalhes': 'Detalhes do Modelo',
  '/pages/modelo/editar': 'Edição de Modelo',

  '/pages/veiculos': 'Veículos',
  '/pages/veiculos/detalhes': 'Detalhes do Veículo',
  '/pages/veiculos/editar': 'Edição de Veículo',
  '/pages/veiculos/criar': 'Cadastro de Veículo',

  '/pages/operacoes': 'Operações',
  '/pages/operacoes/criar': 'Cadastro de Operação',
  '/pages/operacoes/editar': 'Edição de Operação',
  '/pages/operacoes/detalhes': 'Detalhes da Operação',

  '/pages/viagens': 'Viagens',
  '/pages/viagens/detalhes': 'Detalhes da Viagem',
  '/pages/viagens/editar': 'Edição de Viagem',
  '/pages/viagens/criar': 'Cadastro de Viagem',

  '/pages/pedidos': 'Pedidos',
  '/pages/pedidos/criar': 'Cadastro de Pedido',
  '/pages/pedidos/editar': 'Edição de Pedido',
  '/pages/pedidos/detalhes': 'Detalhes do Pedido',

  '/pages/planejamentodetalhado': 'Planejamento detalhado',
  '/pages/planejamentodetalhado/sugestao': 'Sugestão de Frota do Planejamento detalhado',

  '/pages/deposito': 'Depósito',
  '/pages/cobrancas-deposito': 'Cobranças Depósito',
  '/pages/enderecamento': 'Endereçamento',

  '/pages/descarga': 'Descargas',
  '/pages/descarga/dashboard': 'Dashboard de Descargas',
  '/pages/descarga/descargas': 'Descargas',
  '/pages/descarga/descargas/detalhes': 'Detalhes da Descarga',
  '/pages/descarga/janela': 'Janela de Descarga',

  '/pages/dashboard': 'Dashboards',
  '/pages/dashboard/deposito': 'Dashboard de Depósito',
  '/pages/dashboard/premiacao': 'Dashboard de Premiação',
  '/pages/dashboard/motoristas': 'Dashboard de Motoristas',

  '/pages/acompanhamentos': 'Acompanhamentos',
  '/pages/acompanhamentos/criar': 'Cadastro de Acompanhamento',
  '/pages/acompanhamentos/editar': 'Edição de Acompanhamento',
  '/pages/acompanhamentos/detalhes': 'Detalhes do Acompanhamento',

  '/pages/notificacoes': 'Notificações',
  '/pages/previsao-cargas': 'Previsão de Cargas',

  '/pages/containers/programacao': 'Programação de Containers',
  '/pages/containers/programacao/criar': 'Cadastro de Container',
  '/pages/containers/programacao/editar': 'Edição de Container',
  '/pages/containers/programacao/detalhesdepots': 'Detalhes do Container',
  '/pages/containers/anexos': 'Anexos de Containers',

  '/pages/motoristas': 'Motoristas',
  '/pages/motoristas/detalhes': 'Detalhes do Motorista',
  '/pages/motoristas/edicao': 'Edição de Motorista',
  '/pages/motoristas/cadastro': 'Cadastro de Motorista',
};

const normalizar = (pathname) => {
  if (typeof pathname !== 'string') return '';
  const semQuery = pathname.split(/[?#]/)[0];
  return semQuery.length > 1 ? semQuery.replace(/\/+$/, '') : semQuery;
};

/**
 * Nome da tela para o contexto do assistente.
 * @param {string} pathname
 * @returns {string | null} `null` quando a rota não é conhecida.
 */
export const nomeDaTela = (pathname) => {
  let caminho = normalizar(pathname);
  while (caminho) {
    if (Object.prototype.hasOwnProperty.call(NOMES_DE_TELAS, caminho)) return NOMES_DE_TELAS[caminho];
    const ultimaBarra = caminho.lastIndexOf('/');
    if (ultimaBarra <= 0) return null;
    caminho = caminho.slice(0, ultimaBarra);
  }
  return null;
};
